import { createSelector } from '@reduxjs/toolkit';
import { selectQuoteLine } from '@ui/features/quote-builder/state/selectors/quote-line';
import { RootState } from '@ui/store';

export const selectQuoteLineInfo = createSelector(
  [
    (state: RootState, quoteLineUuid: string) =>
      selectQuoteLine(state, quoteLineUuid).isInfoVisible,
    (state: RootState, quoteLineUuid: string) =>
      selectQuoteLine(state, quoteLineUuid).infoTab,
    (state: RootState, quoteLineUuid: string) =>
      selectQuoteLine(state, quoteLineUuid).infoTabOrderHistoryFilterByCustomer,
    (state: RootState, quoteLineUuid: string) =>
      selectQuoteLine(state, quoteLineUuid).infoTabQuoteHistoryFilterByCustomer,
  ],
  (
    isInfoVisible,
    infoTab,
    infoTabOrderHistoryFilterByCustomer,
    infoTabQuoteHistoryFilterByCustomer,
  ) => {
    return {
      isInfoVisible,
      infoTab,
      infoTabOrderHistoryFilterByCustomer,
      infoTabQuoteHistoryFilterByCustomer,
    };
  },
);
